import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

const STUDY_MATERIALS_URL = 'https://landpoint227.sharepoint.com/sites/LandpointTraining2/Landpoint%20Training%20Documents/Forms/AllItems.aspx';

@Component({
  selector: 'app-learning-landing',
  standalone: true,
  imports: [RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './learning-landing.component.html',
  styleUrl: './learning-landing.component.css',
})
export class LearningLandingComponent {
  readonly studyMaterialsUrl = STUDY_MATERIALS_URL;
}
